import { DictionaryConfig } from "@/containers/dictionaries/types";
import { ReadonlyObject } from "@/types/readOnly";
import { TFunction } from "i18next";

type LabelsType = DictionaryConfig<ReadonlyObject, unknown>["labels"];

export function getDictionaryLabels(t: TFunction): LabelsType {
  const processNestedObject = (
    obj: Record<string, unknown>,
  ): Record<string, unknown> => {
    const result: Record<string, unknown> = {};

    Object.entries(obj).forEach(([key, value]) => {
      if (value && typeof value === "object") {
        result[key] = processNestedObject(value as Record<string, unknown>);
      } else if (typeof value === "string") {
        result[key] = t(value);
      }
    });

    return result;
  };

  return processNestedObject(this.labels) as unknown as LabelsType;
}
